import { connectHits } from "instantsearch.js/es/connectors/index.js";

// Show the suppliers card results
export const chamfrSuppliersHits = connectHits(
  (renderOptions, isFirstRender) => {
    const { hits, widgetParams } = renderOptions;
    const container = widgetParams.container;

    if (isFirstRender) {
      container.innerHTML = ""; // Clear the container
    }

    // Generate custom HTML without <ol> or <li>
    container.innerHTML = hits
      .map(
        (hit) => `
		<div class="${
      hit.featured ? "search-results-card featured" : "search-results-card"
    }" id="${hit.key}" data-company="${hit.title}">
			<div class="search-results-card-details">
				<div class="search-results-card-logo">
				<a href="${hit.shop_address || "#"}">
					<img src="${hit.imageURL}" loading="lazy" alt="${hit.title}" />
				</a>
				</div>
				<div class="search-results-card-info">
				<h3 class="search-results-card-info-name">
					<a href="${hit.shop_address || "#"}">${hit.title}</a>
				</h3>
				<ul class="search-results-card-info-tags">
					${(hit.supplier_category || []).map((tag) => `<li>${tag}</li>`).join("")}
				</ul>
				<div class="search-results-card-info-description">
					<p>${hit.description || "No description available."}</p>
				</div>
				<ul class="search-results-card-info-certificate">
					${(hit.qcb || [])
            .map((certificate) => {
              const fileExtension = certificate === "fda" ? "png" : "svg"; // FDA uses png, other use svg
              return `
						<li>
							<img src="https://chamfr.com/wp-content/themes/chamfr2020/assets/images/certificates/${certificate}.${fileExtension}" 
								alt="Certificate: ${certificate}" 
								class="${certificate.toLowerCase()}" />
						</li>
						`;
            })
            .join("")}
				</ul>
			</div>
		</div>
		
			<div class="search-results-card-actions">
				${
          hit.button_text
            ? `<a href="${
                hit.button_link || hit.shop_address || "#"
              }" class="btn btn-primary">${hit.button_text}</a>`
            : ""
        }
				${
          hit.rfq_address
            ? `<a href="${hit.rfq_address}" class="btn btn-outlined">Request Quote</a>`
            : ""
        }
			</div>
		</div>
	`
      )
      .join("");
  }
);
